import { ConstraintFragment, OfferFragment } from '@occc/graphql';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import {
  makeCreateStoreLocationConstraintOperation,
  makeCreateStoreLocationGroupConstraintOperation,
} from '@occc-app/offerHelpers/operations/constraints';

import { StoreLocationOrGroupsFormValues } from './store-location-or-groups.types';

export const getStoreLocationGroupConstraint = (constraints: ConstraintFragment[]) => {
  return constraints.find(constraintHelper.isStoreLocationGroup);
};

export const getStoreLocationConstraint = (offer: OfferFragment | null | undefined) => {
  return offer?.constraints.find(constraintHelper.isStoreLocation);
};

export const getStoreLocationOrGroupsConstraintOperations = (
  offerId: string,
  _offer: OfferFragment | undefined,
  values: StoreLocationOrGroupsFormValues['storeLocationOrGroups'],
  dirtyFields: DirtyFieldsType,
) => {
  const operations: Operation[] = [];

  const isLocationsDirty =
    isFieldDirty<StoreLocationOrGroupsFormValues>(
      dirtyFields,
      'storeLocationOrGroups.storeLocation.locations',
    ) ||
    isFieldDirty<StoreLocationOrGroupsFormValues>(
      dirtyFields,
      'storeLocationOrGroups.storeLocation.evaluationMethod',
    );
  const isLocationGroupsDirty = isFieldDirty<StoreLocationOrGroupsFormValues>(
    dirtyFields,
    'storeLocationOrGroups.storeLocationGroup.locationGroups',
  );
  const isTypeDirty = isFieldDirty<StoreLocationOrGroupsFormValues>(
    dirtyFields,
    'storeLocationOrGroups.type',
  );
  if (!isLocationGroupsDirty && !isLocationsDirty && !isTypeDirty) {
    return operations;
  }

  if (values.storeLocation.id) {
    operations.push(makeDeleteOperation('constraintDelete', values.storeLocation.id));
  }

  if (values.storeLocationGroup.id) {
    operations.push(makeDeleteOperation('constraintDelete', values.storeLocationGroup.id));
  }

  if (values.type === 'storeLocation' && values.storeLocation.locations?.length) {
    const locationIds = values.storeLocation.locations.map((item) => item.uuid);

    operations.push(
      makeCreateStoreLocationConstraintOperation(
        offerId,
        values.storeLocation.evaluationMethod,
        locationIds,
      ),
    );
  } else if (
    values.type === 'storeLocationGroups' &&
    values.storeLocationGroup.locationGroups?.length
  ) {
    const locationGroupUuids = values.storeLocationGroup.locationGroups.map((item) => item.uuid);

    operations.push(makeCreateStoreLocationGroupConstraintOperation(offerId, locationGroupUuids));
  }

  return operations;
};
